// 🔧 bundle_service.js
// ✅ Purpose: Orchestrates Content Bundle generation and publishing
// ✅ Features:
// - Retrieves published Content Items through the Firestore Provider
// - Builds optimized runtime Content Bundles
// - Saves published bundles
// - Keeps orchestration separate from transformation logic
// - Contains no React logic
// - Contains no Firestore implementation details
// - Future-ready for manifest rebuilding, cache invalidation, and publish workflows

import {
  queryContentItems,
} from "../providers/firestore_read_provider";

import {
  saveContentBundle,
} from "../providers/firestore_write_provider";

import {
  CONTENT_STATUSES,
} from "../constants/content_statuses";

import {
  buildContentBundle,
} from "./bundle_builder";

/**
 * ============================================================================
 * Bundle Service Philosophy
 * ============================================================================
 *
 * Provider
 *      ↓
 * Published Content Items
 *
 * Bundle Builder
 *      ↓
 * Runtime Bundle
 *
 * Provider
 *      ↓
 * Save Bundle
 *
 * ============================================================================
 */

/**
 * Builds a runtime bundle for one Content Area.
 *
 * Example:
 *
 * buildAndPublishBundle({
 *     area: "event_home",
 *     scopeId: "global",
 *     locale: "en-US",
 *     profile: "default",
 * })
 */
export async function buildAndPublishBundle({
  area,

  scopeId,
  locale,
  profile,

  version = 1,
  generatedBy = null,
}) {
  console.log(
    "[Content Engine] Building published bundle:",
    area
  );

  /**
   * ----------------------------------------------------------
   * Retrieve published content items.
   * ----------------------------------------------------------
   */

    const contentItems =
    await queryContentItems({
        area,
        status: CONTENT_STATUSES.PUBLISHED,
        scopeId,
        locale,
        profile,
    });

    console.log(
      "[Content Engine] Published content items:",
      contentItems.length,
      contentItems
    );

  /**
   * ----------------------------------------------------------
   * Build runtime bundle.
   * ----------------------------------------------------------
   */

  const bundle = buildContentBundle({
    area,

    contentItems,

    bundleOptions: {
      scopeId,
      locale,
      profile,

      version,

      generatedAt: Date.now(),

      generatedBy,
    },
  });

  console.log(
    "[Content Engine] Built bundle:",
    bundle
  );

  /**
   * ----------------------------------------------------------
   * Save runtime bundle.
   * ----------------------------------------------------------
   */

    await saveContentBundle(
    bundle.bundleKey,
    bundle
    );

    console.log(
        "[Content Engine] Bundle published:",
        bundle.bundleKey
    );

  return bundle;
}

/**
 * Rebuilds multiple bundles.
 *
 * Input:
 *
 * [
 *   "event_home",
 *   "dashboard",
 *   "request_event"
 * ]
 */
export async function buildAndPublishBundles({
  areas = [],

  scopeId,
  locale,
  profile,

  generatedBy = null,
}) {
  const results = [];

  for (const area of areas) {
    const bundle =
      await buildAndPublishBundle({
        area,

        scopeId,
        locale,
        profile,

        generatedBy,
      });

    results.push(bundle);
  }

  return results;
}